var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside__line"},[_c('div',{staticClass:"scrollbar"},[_c('div',{staticClass:"scrollbar__line",style:({ transform: ("scaleY(" + (_vm.$route.name === 'home' ? _vm.scrollHome : _vm.scroll) + ")") })})])])}
var staticRenderFns = []

export { render, staticRenderFns }